var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburgerSetings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.4,
    height: 24.7,
    viewBox: "0 0 36.4 24.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "menu_FILL1_wght500_GRAD0_opsz48",
    d: "M7.5,36.35a1.637,1.637,0,0,1-1.2-.5,1.7,1.7,0,0,1-.5-1.25,1.556,1.556,0,0,1,.5-1.175,1.681,1.681,0,0,1,1.2-.475h33a1.681,1.681,0,0,1,1.2.475,1.614,1.614,0,0,1,.5,1.225,1.707,1.707,0,0,1-1.7,1.7Zm0-10.65A1.707,1.707,0,0,1,5.8,24a1.614,1.614,0,0,1,.5-1.225A1.681,1.681,0,0,1,7.5,22.3h33A1.707,1.707,0,0,1,42.2,24a1.614,1.614,0,0,1-.5,1.225,1.681,1.681,0,0,1-1.2.475Zm0-10.65a1.681,1.681,0,0,1-1.2-.475,1.614,1.614,0,0,1-.5-1.225,1.707,1.707,0,0,1,1.7-1.7h33a1.637,1.637,0,0,1,1.2.5,1.7,1.7,0,0,1,.5,1.25,1.556,1.556,0,0,1-.5,1.175,1.681,1.681,0,0,1-1.2.475Z",
    transform: "translate(-5.8 -11.65)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerSetings);
export default __webpack_public_path__ + "static/media/hamburger_setings.03b5a30a5acdb5da45cb39e47a4d2fe6.svg";
export { ForwardRef as ReactComponent };